var render = function render(){var _vm=this,_c=_vm._self._c;return _c('prism-editor',{staticClass:"code-editor",attrs:{"code":_vm.code,"highlight":_vm.highlighter,"readonly":_vm.readonly,"line-numbers":""},model:{value:(_vm.editableCode),callback:function ($$v) {_vm.editableCode=$$v},expression:"editableCode"}})
}
var staticRenderFns = []

export { render, staticRenderFns }